import { Utils } from "@/plugins/utils"

export default {
	namespaced: true,
	state: {
		items: [],
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false,
	},
	getters: {
		getLoading(state) {
			return state.loading
		},
		getItemsPerPage(state) {
			return state.itemsPerPage
		},
		getItems(state) {
			return state.items
		},
	},
	mutations: {
		set(state, items) {
			state.items = Array.isArray(items) ? items : []
			state.hasNext = false
		},
		setLoading(state, flag) {
			state.loading = !!flag
		},
		setParamsDataTable(state, payload) {
			state.items = payload.items || []
			state.itemsPerPage = payload.limit || state.itemsPerPage
			state.hasNext = !!payload.hasNext
		},
	},
	actions: {
		async find(store, payload = null) {
			store.commit("setLoading", true)
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Carregando comissões", indeterminate: true },
				{ root: true },
			)

			let result = null
			try {
				const response = await this._vm.$axios.get("/Representative/CommissionGrid/FindList")
				const data = Utils.ValidateAxiosResponse(response.data)
				if (Array.isArray(data)) {
					store.commit("set", data)
					result = data
				} else if (data && Array.isArray(data.items)) {
					store.commit("setParamsDataTable", data)
					result = data.items
				} else {
					store.commit("set", [])
					result = []
				}
			} catch (error) {
				store.dispatch(
					"parameters/openDialog",
					{
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					},
					{ root: true },
				)
				result = null
			} finally {
				store.commit("setLoading", false)
				store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			}

			return result
		},
		async search(store, { limit = 20, page = 1 } = {}) {
			store.commit("setLoading", true)
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Carregando comissões", indeterminate: true },
				{ root: true },
			)

			let result = null
			try {
				const response = await this._vm.$axios.get(
					`/Representative/CommissionGrid/Search?search=${store.state.search}&limit=${limit}&page=${page}`,
				)
				const data = Utils.ValidateAxiosResponse(response.data)
				if (Array.isArray(data)) {
					store.commit("set", data)
					result = data
				} else if (data && Array.isArray(data.items)) {
					store.commit("setParamsDataTable", data)
					result = data.items
				} else {
					store.commit("set", [])
					result = []
				}
			} catch (error) {
				store.dispatch(
					"parameters/openDialog",
					{
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					},
					{ root: true },
				)
				result = null
			} finally {
				store.commit("setLoading", false)
				store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			}

			return result
		},
		async findProducts(store, { veacliente = "", veavend = "" } = {}) {
			store.commit("setLoading", true)
			store.dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Carregando produtos", indeterminate: true },
				{ root: true },
			)

			let result = null
			try {
				const response = await this._vm.$axios.post("/Representative/CommissionGrid/FindProducts", {
					veacliente,
					veavend,
				})
				const data = Utils.ValidateAxiosResponse(response.data)
				if (data && data.items) {
					store.commit("setParamsDataTable", data)
					result = data.items
				} else {
					store.commit("set", data)
					result = data || []
				}
			} catch (error) {
				store.dispatch(
					"parameters/openDialog",
					{
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					},
					{ root: true },
				)
				result = null
			} finally {
				store.commit("setLoading", false)
				store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			}

			return result
		},
		async findProduct(store, { veacliente = "", veavend = "", veaproduto = "", silent = false } = {}) {
			store.commit("setLoading", true)

			if (!silent) {
				store.dispatch(
					"parameters/openGlobalLoading",
					{ showLoadingGlobal: true, text: "Carregando produto", indeterminate: true },
					{ root: true },
				)
			}

			let result = null
			try {
				const response = await this._vm.$axios.post("/Representative/CommissionGrid/FindProduct", {
					veacliente,
					veavend,
					veaproduto,
				})
				const data = Utils.ValidateAxiosResponse(response.data)
				result = data || null
			} catch (error) {
				store.dispatch(
					"parameters/openDialog",
					{ titleText: "Erro", titleColor: "red", text: error.message },
					{ root: true },
				)
				result = null
			} finally {
				store.commit("setLoading", false)
				if (!silent) {
					store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
				}
			}

			return result
		},
	},
}
